import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

export default function Login() {
  const { login, API } = useAuth();
  const nav = useNavigate();
  const [tab, setTab] = useState('login');
  const [form, setForm] = useState({
    nombre: '', email: '', password: '',
    cedula: '', celular: '', empresa: '', cargo: ''
  });
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const handle = e => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async e => {
    e.preventDefault();
    setError(''); setMsg(''); setLoading(true);
    try {
      if (tab === 'login') {
        await login(form.email, form.password);
        nav('/');
      } else {
        await axios.post(`${API}/registro`, form);
        setMsg('Registro exitoso. Espera aprobación del administrador.');
        setTab('login');
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Error, intenta de nuevo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo}>🏦</div>
        <h1 style={styles.title}>ConciliaApp</h1>
        <p style={styles.sub}>Conciliación bancaria</p>
        <div style={styles.tabs}>
          {['login', 'registro'].map(t => (
            <button key={t} style={{ ...styles.tab, ...(tab === t ? styles.tabActive : {}) }} onClick={() => setTab(t)}>
              {t === 'login' ? 'Ingresar' : 'Registrarse'}
            </button>
          ))}
        </div>
        <form onSubmit={submit} style={styles.form}>
          {tab === 'registro' && (
            <>
              <input style={styles.input} name="nombre" placeholder="Nombre completo *" value={form.nombre} onChange={handle} required />
              <div style={styles.row}>
                <input style={styles.input} name="cedula" placeholder="Cédula o NIT *" value={form.cedula} onChange={handle} required />
                <input style={styles.input} name="celular" placeholder="Celular *" value={form.celular} onChange={handle} required />
              </div>
              <input style={styles.input} name="empresa" placeholder="Empresa" value={form.empresa} onChange={handle} />
              <input style={styles.input} name="cargo" placeholder="Cargo" value={form.cargo} onChange={handle} />
            </>
          )}
          <input style={styles.input} name="email" type="email" placeholder="Correo electrónico *" value={form.email} onChange={handle} required />
          <input style={styles.input} name="password" type="password" placeholder="Contraseña *" value={form.password} onChange={handle} required />
          {error && <p style={styles.error}>{error}</p>}
          {msg && <p style={styles.success}>{msg}</p>}
          <button style={styles.btn} disabled={loading}>
            {loading ? 'Cargando...' : tab === 'login' ? 'Ingresar' : 'Crear cuenta'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f4f4f5' },
  card: { background: '#fff', borderRadius: 16, padding: '2.5rem 2rem', width: 400, boxShadow: '0 4px 24px rgba(0,0,0,0.08)' },
  logo: { fontSize: 40, textAlign: 'center', marginBottom: 8 },
  title: { textAlign: 'center', fontSize: 22, fontWeight: 600, margin: 0 },
  sub: { textAlign: 'center', color: '#666', fontSize: 14, marginBottom: 24, marginTop: 4 },
  tabs: { display: 'flex', background: '#f4f4f5', borderRadius: 10, padding: 4, marginBottom: 20 },
  tab: { flex: 1, padding: '8px 0', border: 'none', background: 'transparent', cursor: 'pointer', borderRadius: 8, fontSize: 14, color: '#555' },
  tabActive: { background: '#fff', fontWeight: 600, color: '#111', boxShadow: '0 1px 4px rgba(0,0,0,0.1)' },
  form: { display: 'flex', flexDirection: 'column', gap: 10 },
  row: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 },
  input: { padding: '10px 14px', borderRadius: 8, border: '1px solid #e0e0e0', fontSize: 14, outline: 'none', width: '100%', boxSizing: 'border-box' },
  btn: { padding: '12px', borderRadius: 8, background: '#2563eb', color: '#fff', border: 'none', fontWeight: 600, fontSize: 15, cursor: 'pointer', marginTop: 4 },
  error: { color: '#dc2626', fontSize: 13, margin: 0 },
  success: { color: '#16a34a', fontSize: 13, margin: 0 }
};
